export default "__VITE_ASSET__af1865b7__"